export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const LOGIN_PATH = "/login";
export const PUBLIC_PATHS = ["/sign-up","/forgot"];
